import React from 'react';
import { Box, Spinner } from '@chakra-ui/react';
import './loader.css';
type PropType = {
  inline: boolean;
};

const defaultProp: Partial<PropType> = {
  inline: false,
};

function Loader(props: PropType) {
  return (
    <Box className="overlay" position={props.inline ? 'absolute' : 'fixed'}>
      <Spinner
        thickness="2.5px"
        speed="0.65s"
        emptyColor="rgba(0,0,0,0.18)"
        color={'#59BEF7'}
        size="lg"
      />
    </Box>
  );
}

Loader.defaultProps = defaultProp;
export default Loader;
